import React from 'react';
import {bool, node, oneOf, string} from 'prop-types';
import styles from './Flyover.scss';
import classNames from 'classnames';

const Flyover = ({isOn, size, theme, children, className}) => (
  <div className={classNames(styles[size], styles[theme], {[styles.isOn]: isOn}, className)}>
    {children}
  </div>
);

Flyover.propTypes = {
  isOn: bool,
  size: oneOf(['fullscreen', 'content']),
  children: node,
  className: string,
  theme: oneOf(['default', 'teaser']),
};

Flyover.defaultProps = {
  isOn: false,
  size: 'fullscreen',
  children: null,
  className: undefined,
  theme: 'default',
};

export default Flyover;
